import {
    GOOGLE_ANALYTICS,
    META_PIXEL,
    LINKEDIN_INSIGHT,
    MARKETO_MUNCHKIN,
    GOOGLE_TAG_MANAGER,
} from 'common/constants/thirdPartyTrackingManager';

/**
 * Gets the initializing function for each of the tracker plugins
 * @async
 *
 * @param {string} options.trackerType - the tracker type to get the associated initializer fn
 * @returns {function} - analytics plugin initializer
 */
async function getTrackerPluginInitializer({ trackerType }) {
    const TRACKER_PLUGIN_INITIALIZER_MAP = {
        [GOOGLE_ANALYTICS]: './googleAnalytics',
        [META_PIXEL]: './metaPixel',
        [LINKEDIN_INSIGHT]: './linkedInInsight',
        [MARKETO_MUNCHKIN]: './marketoMunchkin',
        [GOOGLE_TAG_MANAGER]: './googleTagManager',
    };

    const { default: trackerPluginInitializer } = await import(`${TRACKER_PLUGIN_INITIALIZER_MAP[trackerType]}`);

    return trackerPluginInitializer;
}

export default getTrackerPluginInitializer;
